/** @format */

import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import RefreshIcon from '@material-ui/icons/Refresh';
import COLORS from '../../../../assets/themes/OPL/colors';
import I18n from '../../../../components/Translate/I18n';

export type MetricType = 'W01' | 'W04' | 'W05';

export interface MetricTypeConfig {
    type: MetricType;
    label: string;
}

interface MetricTypeSelectorProps {
    metricTypes: MetricTypeConfig[];
    selectedMetricType: MetricType | null;
    loading: boolean;
    onMetricTypeChange: (metricType: MetricType) => void;
    onReload: () => void;
}

const MetricTypeSelector: React.FC<MetricTypeSelectorProps> = ({
    metricTypes,
    selectedMetricType,
    loading,
    onMetricTypeChange,
    onReload,
}) => {
    return (
        <Card>
            <CardHeader title={<I18n trans="specialized_report:dashboard.title" />} />
            <CardContent>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <ButtonGroup variant="contained" color="primary">
                        {metricTypes.map((metric) => (
                            <Button
                                key={metric.type}
                                onClick={(): void => onMetricTypeChange(metric.type)}
                                style={{
                                    backgroundColor:
                                        selectedMetricType === metric.type
                                            ? COLORS.MAIN.PRIMARY
                                            : '#333',
                                    color: COLORS.MAIN.LIGHT,
                                }}
                            >
                                <I18n trans={`specialized_report:dashboard.metric_types.${metric.type}`} />
                            </Button>
                        ))}
                    </ButtonGroup>

                    {selectedMetricType && (
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<RefreshIcon />}
                            onClick={onReload}
                            disabled={loading}
                            style={{
                                borderColor: COLORS.MAIN.PRIMARY,
                                color: COLORS.MAIN.PRIMARY,
                            }}
                        >
                            <I18n trans="specialized_report:dashboard.refresh" />
                        </Button>
                    )}
                </div>
            </CardContent>
        </Card>
    );
};

export default MetricTypeSelector;
